<template>
  <div>
    <TableList
      ref="table"
      :cols="cols"
      :list="list"
      :height="tableHeight"
      :rowHeight="100"
    >
      <template slot="mainImagesSlot" slot-scope="{ row }">
        <el-image :src="row.mainImages" fit="cover" style="width:40px;height:40px"></el-image>
      </template>
       <template slot="statusSlot" slot-scope="{ row }">
        <span v-if='row.status==1' style="color:#396CF3">{{put_status_map[row.status]}}</span>
        <span v-else-if='row.status==2' style="color:#FD8944">{{put_status_map[row.status]}}</span>
        <span v-else style="color:red">{{put_status_map[row.status]}}</span>
      </template>
      <template slot="opcolsSlot" slot-scope="{ row }" v-if="row.status==3">
        <el-button type="link" @click="openPhDialog(row)" >编辑/重新提报</el-button>
      </template>
    </TableList>
     <!-- 编辑窗口 -->
    <EditDialog ref="editDialog" @search="$emit('search')"/>
  </div>
</template>

<script>
import EditDialog from "@/components/prod/center/dialogs/EditDialog.vue";
import TableList from "@/components/TableList.vue";
import prod_center_dictionary from "@/components/prod/center/dictionary.js";
import tableMixins from '@mixins/table-mixins';
import { mapActions, mapMutations, mapGetters} from "vuex";

export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    mode: {
      type: String,
      default: "supplier",
    },
  },
  mixins: [new tableMixins(176,{ refName:'search' })],
  components: {
    TableList,
    EditDialog
  },
  data() {
    return {
      cols: [
        { prop: "mainImages", attrs: { label: "图片" }, slot: true},
        { prop: "outerId", attrs: { label: "款式编码" } },
        { prop: "status", attrs: { label: "提报状态" }, slot: true  },
        { prop: "supply", attrs: { label: "提报人" } },
        { prop: "supplyTime", attrs: { label: "提报时间" } },
        { prop: "detail", attrs: { label: "详情" } },
        { prop: "opcols", attrs: { label: "操作" }, slot: true }
      ],
    };
  },
  computed: {
    ...mapGetters(['routerPrefix']),
    put_status_map() {
      const { PUT_STATUS_MAP }  = prod_center_dictionary;
      return PUT_STATUS_MAP;
    }
  },
  mounted() {
    let featureCodes = this.$store.getters.featureCodes;
    let showPutGoods = featureCodes?.includes('PublicSourceReport');
    let joinOcean = this.$store.getters.getJoinOcean;
    // 如果 showPutGoods 为false,则不显示提报状态
    if (!showPutGoods || !joinOcean) {
      this.cols = this.cols.filter(col => col.prop !== 'status');
    }
  },
  methods: {
    ...mapActions(['publishSpeed']),
    ...mapMutations(['setCurrentPage']),
    showPublishSpeed(rowData) {
      this.setCurrentPage(`${this.routerPrefix}log`);
      this.publishSpeed({publishType: rowData.publishType, resultVisible: true, batchTaskId: rowData.batchTaskId})
    },
    openPhDialog(row){
      row.companyId = this.$store.getters?.userInfo?.companyId || '';
      this.$refs.editDialog.method_open(row,{isPublicSourceReport:true});
    }
  },
};
</script>

<style lang="scss" scoped>

</style>
